import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataImageListForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

import './incidentDetailsLinkDataImageList.less';

const IncidentDetailsLinkDataImageList = ({
  editable = true,
  forceValidation,
  linkImageListLinkData,
  linkImageListLinkDataChange,
  linkImageListLinkDataValidate,
  linkImageListLinkMetadata,
}) => (
  <div className="incident-details-image-list-container">
    <Divider />
    <h3 className="mb-18">
      {translate('reporting.incidentDetails.imageList.title')}
    </h3>
    <LinkDataImageListForm
      editable={editable}
      forceValidation={forceValidation}
      linkImageListLinkData={linkImageListLinkData}
      linkImageListLinkMetadata={linkImageListLinkMetadata}
      onChange={linkImageListLinkDataChange}
      onValidate={linkImageListLinkDataValidate}
      shouldIgnoreMandatoryValidation
      shouldSelectMainImage
    />
  </div>
);

export default IncidentDetailsLinkDataImageList;
